import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'PHONE_NUMBER_PATCH',
  PATCH_SUCCESS: 'PHONE_NUMBER_PATCH_SUCCESS',
  PATCH_FAILURE: 'PHONE_NUMBER_PATCH_FAILURE',
};

export const patch = actions.patch(
  studentId => `${BASE_URL}/students/${studentId}/update_phone/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
